export const TICKETS_ORDERS_ROUTE = '/tickets-orders';

export const TICKETS_SCANS_ROUTE = '/tickets-scans';

export const TICKETS_ORDERS_FULL = `${TICKETS_ORDERS_ROUTE}/:id`;
export const getOrdersFullRoute = (id: string | number) => `${TICKETS_ORDERS_ROUTE}/${id}`;
